import { CommitmentSetupTabProps } from "features/commitments/setup/CommitmentSetupTabProps";
import { useCommitmentInformationRetrieveSuspense } from "gen/endpoints/commitment-information/commitment-information";
import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import PageBody from "shared/components/layout/PageBody";
import PageContent from "shared/components/layout/PageContent";
import { PageHeader } from "shared/components/layout/PageHeader";
import { PageTabs } from "shared/components/layout/PageTabs";
import { useRequiredStringParams } from "shared/hooks/useRequiredStringParams";
import { rootRoute } from "shared/navigation/Routes";

export const CommitmentSetupPage: React.FC = () => {
  const { t } = useTranslation(["commitment", "common"]);
  const navigate = useNavigate();

  const { fundFamilyId, commitmentId } = useRequiredStringParams();

  const { data: commitmentDetails } = useCommitmentInformationRetrieveSuspense(
    fundFamilyId,
    commitmentId,
  );

  const onCancel = useCallback(() => {
    navigate(
      rootRoute({})
        .fundFamilies({})
        .fundFamily({ fundFamilyId })
        .setup({})
        .commitments({}).$,
    );
  }, [fundFamilyId, navigate]);

  const tabProps: CommitmentSetupTabProps = {
    fundFamilyId,
    commitmentId,
    fundId: commitmentDetails.owned_entity_id,
    investorClassId: commitmentDetails.investor_class_id,
    onCancel,
  };

  return (
    <PageContent contentWidth="boxed">
      <PageHeader
        title={t("commitment:title", {
          name: commitmentDetails.owning_entity_legal_name,
        })}
        backButton={{
          title: t("common:commitments"),
          path: rootRoute({})
            .fundFamilies({})
            .fundFamily({ fundFamilyId })
            .setup({})
            .commitments({}).$,
        }}
      />
      <PageBody>
        <PageTabs context={tabProps} />
      </PageBody>
    </PageContent>
  );
};
